// extracted by mini-css-extract-plugin
module.exports = {"statsBanner":"StatsBanner_statsBanner__2xpsr","statsItem":"StatsBanner_statsItem__2FHJD","imgTxt":"StatsBanner_imgTxt__88ErM"};